<template>
    <div class="mvt-range group-range">
        <button type="button" v-ga:clickable="item.value" :min="_value[0] === item.value" :max="_value[1]!==0  && _value[1] === item.value || _value[1]===_value[0] && _value[0]===item.value"  v-for="(item, index) in data"
            @click="changeRange(item.value)" v-html="item.text"></button>
    </div>
</template>
<script src="./mvt-range.js"></script>
